import axios from 'axios';

axios.defaults.headers.common['AuthorizationToken'] = gon.self_reg_token;
axios.defaults.headers.common['AuthorizationUid'] = gon.uid;
axios.defaults.headers.common['AuthorizationOrgId'] = gon.organization_id;

export const baseApiUrl = `/organizations/${gon.organization_id}/api/v1`;
